/**
 * @generated SignedSource<<163703d5288ac7dda182ad1cdbe25764>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoggedInNavFragment$data = {
  readonly viewer: {
    readonly __typename: "Viewer";
    readonly user: {
      readonly username: string | null;
    } | null;
    readonly viewerGalleries: ReadonlyArray<{
      readonly gallery: {
        readonly dbid: string;
      } | null;
    } | null> | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EditUserInfoModalFragment" | "ManageWalletsModalFragment" | "isFeatureEnabledFragment">;
  readonly " $fragmentType": "LoggedInNavFragment";
};
export type LoggedInNavFragment$key = {
  readonly " $data"?: LoggedInNavFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoggedInNavFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dbid",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoggedInNavFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditUserInfoModalFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageWalletsModalFragment"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "isFeatureEnabledFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GalleryUser",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "Viewer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ViewerGallery",
              "kind": "LinkedField",
              "name": "viewerGalleries",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Gallery",
                  "kind": "LinkedField",
                  "name": "gallery",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4d1aca996a7ae3ecce651141ad2c3d88";

export default node;
